<template>
  <div>
    <el-tabs class="knowledgeTabs" v-model="knowledgeType" @tab-click="handleClick">
      <el-tab-pane name="chapterKnowledge">
        <p slot="label">
          <span class="edition">{{ materialBook.EditionName }}</span>
          -
          <span class="book">{{ materialBook.Name }}</span>
          <a href="#" style="margin-left: 10px; color: #606266; font-size: 14px;" @click="materiaVisiable = true">
            <i class="el-icon-setting" style="font-weight: 600;"></i>
          </a>
        </p>
        <el-cascader
          ref="bookKnowledge"
          v-model="knowledgeList"
          placeholder="试试搜索知识点"
          :options="bookKnowledgeOptions"
          :props="bookKnowledgeProps"
          :show-all-levels="false"
          filterable
          style="width: 100%"
          @change="handleChange"
        ></el-cascader>
      </el-tab-pane>
      <el-tab-pane label="学科知识点" name="subjectKnowledge">
        <el-cascader
          ref="subjectKnowledge"
          v-model="knowledgeList"
          placeholder="试试搜索知识点"
          :options="subjectKnowledgeOptions"
          :props="subjectKnowledgeProps"
          :show-all-levels="false"
          filterable
          style="width: 100%"
          @change="handleChange"
        ></el-cascader>
      </el-tab-pane>
    </el-tabs>

    <!--  选择教材 start  -->
    <el-dialog
      :visible.sync="materiaVisiable"
      class="chooseMateria"
      title="选择教材"
      width="40vw"
      append-to-body
      @close="materiaVisiable = false"
    >
      <el-cascader
        ref="material"
        v-model="materiaDialoglList"
        :options="materiaDialogOptions"
        :props="materiaDialogProps"
        style="width: 100%"
      ></el-cascader>
      <span slot="footer" class="dialog-footer">
        <el-button @click="materiaVisiable = false">取 消</el-button>
        <el-button type="primary" @click="confirmMaterial">确 定</el-button>
      </span>
    </el-dialog>
    <!--  选择教材 end  -->
  </div>
</template>
<script>
export default {
  props: {
    knowledgePoints: {
      type: [Array],
      default: [],
    },
  },
  data() {
    let self = this;
    return {
      book: localStorage["book"],
      knowledgeType: "chapterKnowledge",
      materialSubject: {},
      materialEdition: {},
      materialBook: {},
      materiaVisiable: false,
      materiaDialoglList: [],
      materiaDialogOptions: [],
      materiaDialogProps: {
        lazy: true,
        lazyLoad: self.booksLoad,
        label: "name",
        value: "value",
        children: "children",
      },
      knowledgeList: [],
      bookKnowledgeOptions: [],
      bookKnowledgeProps: { multiple: true },
      subjectKnowledgeOptions: [],
      subjectKnowledgeProps: {
        multiple: true,
        label: "Name",
        value: "No",
        children: "datalist",
      },
      handleChangeFlag: false, //标记手动选择知识点触发的改变，避免watch重复执行
    };
  },
  methods: {
    booksLoad(node, resolve) {
      switch (node.level) {
        case 0:
          this.axios.get(window.hosturl + "/hdkt/GetNewBookSubject").then((res) => {
            var data = res.data.data;
            data.map((v) => {
              v.name = v.Name;
              v.value = v.EnglishName;
              v.leaf = node.level >= 2 ? true : false;
            });

            resolve(data);
          });
          break;
        case 1:
          this.axios.get(window.hosturl + "/hdkt/GetNewBookEdition?SubEnglishName=" + node.value).then((res) => {
            var data = res.data.data;
            data.map((v) => {
              v.name = v.Name;
              v.value = v.EditionID;
              v.leaf = node.level >= 2 ? true : false;
            });

            resolve(data);
          });
          this.materialSubject = node.data;
          break;
        case 2:
          this.axios
            .get(
              window.hosturl +
                "/hdkt/GetNewBookList?SubEnglishName=" +
                node.data.Subject +
                "&EditionID=" +
                node.data.EditionID
            )
            .then((res) => {
              var data = res.data.data;
              data.map((v) => {
                v.name = v.Name;
                v.value = v.ID;
                v.leaf = node.level >= 2 ? true : false;
              });

              resolve(data);
            });
          this.materialEdition = node.data;
          break;
      }
    },
    handleChange(val) {
      //知识点选择变了
      //标记手动选择数据变化了，变化处理在此处，watch里无需重复处理
      this.handleChangeFlag = true;

      if (this.knowledgeList.length > 0) {
        let points = [];
        if (this.knowledgeType == "chapterKnowledge") {
          const node1 = this.$refs.bookKnowledge.getCheckedNodes();
          for (let node of node1) {
            let pathNodes = node.pathNodes;
            points.push({
              PointName: pathNodes[pathNodes.length - 1].label,
              PointNo: pathNodes[pathNodes.length - 1].value,
            });
          }
        } else {
          const node2 = this.$refs.subjectKnowledge.getCheckedNodes();
          for (let node of node2) {
            let pathNodes = node.pathNodes;
            points.push({
              PointName: pathNodes[pathNodes.length - 1].label,
              PointNo: pathNodes[pathNodes.length - 1].value,
            });
          }
        }
        this.$emit("pointsChanged", points);
      }
    },
    handleClick(tab, event) {
      if (tab.name == "chapterKnowledge") {
        this.getChapterKnowledges(this.materialBook.ID);
      } else {
        this.getSubjectKnowledges(this.materialBook.SubjectID);
      }
    },
    /**
     * 确认选择教材
     */
    confirmMaterial() {
      const node = this.$refs.material.getCheckedNodes();
      this.materialBook = node[0].data;
      this.Material = node[0].pathLabels.join("/");
      this.materiaVisiable = false;
      let bookId = this.materiaDialoglList[2];
      this.getChapterKnowledges(bookId);
    },
    /**
     * 获取学科知识点
     * @param pd 请求参数
     * @param callback 回调函数
     */
    getSubjectKnowledges(subjectId) {
      this.axios
        .get(window.hosturl + "/rest/questionBank/GetKnowledgePoinForSubject?Subject=" + subjectId)
        .then((res) => {
          if (res.data.result === 200) {
            let kData = res.data.data;
            this.subjectKnowledgeOptions = this.filerSKnowledgeCascader(kData);
            if (this.knowledgePoints.length > 0) {
              this.knowledgeList = [];
              this.setDefaultValue2(this.subjectKnowledgeOptions, []);
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error("学科知识点获取失败");
        });
    },
    /**
     * 获取章节知识点
     * @param pd 请求参数
     * @param callback 回调函数
     */
    getChapterKnowledges(bookId) {
      this.axios
        .get(window.hosturl + "/rest/questionBank/GetClassroomMaterials?BookId=" + bookId)
        .then((res) => {
          if (res.data.result === 200) {
            let kData = res.data.data.datalist;
            this.bookKnowledgeOptions = this.filerChapterCascader(kData);
            if (this.knowledgePoints.length > 0) {
              this.knowledgeList = [];
              this.setDefaultValue(this.bookKnowledgeOptions, []);
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    /* 设置章节知识点树级联选择器的默认选择值 */
    setDefaultValue(da, nodes) {
      for (let item of da) {
        if (item.children && item.children.length > 0) {
          nodes.push(item.value);
          let newNodes = [].concat(nodes);
          this.setDefaultValue(item.children, newNodes);
          nodes.pop();
        } else {
          //最后一级是章节关联的知识点，上面几级都是章节
          for (let k of this.knowledgePoints) {
            if (k.PointNo == item.No) {
              let kp = [].concat(nodes);
              kp.push(item.No);
              this.knowledgeList.push(kp);
            }
          }
        }
      }
    },
    /* 设置学科知识点树级联选择器的默认选择值 */
    setDefaultValue2(da, nodes) {
      for (let item of da) {
        if (item.datalist && item.datalist.length > 0) {
          nodes.push(item.No);
          //不是最后一级，复制父节点数组，递归下一级
          let newNodes = [].concat(nodes);
          this.setDefaultValue2(item.datalist, newNodes);
          nodes.pop();
        } else {
          //最后一级是章节关联的知识点，上面几级都是章节
          for (let k of this.knowledgePoints) {
            if (k.PointNo == item.No) {
              let kp = [].concat(nodes);
              kp.push(item.No);
              this.knowledgeList.push(kp);
              break;
            }
          }
        }
      }
    },

    /**
     * 过滤章节知识点树数据，整理成cascader格式的级联数据.
     * @param da
     * @return {*}
     */
    filerChapterCascader(da) {
      if (da.length > 0) {
        for (let item of da) {
          item.label = item.ChapterName;
          item.value = item.ChapterID;
          if (item.ChildrenList.length > 0) {
            item.children = item.ChildrenList;
            this.filerChapterCascader(item.ChildrenList);
          } else if (item.KnowledgeList.length > 0) {
            //最后一级是章节关联的知识点，上面几级都是章节
            item.children = item.KnowledgeList;
            for (let knowledge of item.KnowledgeList) {
              knowledge.label = knowledge.Name;
              knowledge.value = knowledge.No;
            }
          }
        }
      }
      return da;
    },
    /**
     * 过滤学科知识点树数据，整理成cascader格式的级联数据.
     * @param da
     * @return {*}
     */
    filerSKnowledgeCascader(da) {
      for (let item of da) {
        if (item.datalist.length > 0) {
          this.filerSKnowledgeCascader(item.datalist);
        } else {
          delete item.datalist;
        }
      }
      return da;
    },
  },
  mounted() {
    this.materialBook = {
      ID: localStorage["bookID"],
      Name: localStorage["v3"],
      SubjectID: localStorage["subjectID"],
      SubjectName: localStorage["v1"],
      EditionID: localStorage["editionID"],
      EditionName: localStorage["v2"],
    };
    if (
      this.materialBook.ID &&
      this.materialBook.EditionName != "小升初" &&
      this.materialBook.EditionName != "中考" &&
      this.materialBook.EditionName != "高考"
    ) {
      this.knowledgeType = "chapterKnowledge";
    } else {
      this.knowledgeType = "subjectKnowledge";
    }
    if (this.materialBook.Name.indexOf("复习") != -1) {
      this.getSubjectKnowledges(this.materialBook.SubjectID);
    } else {
      this.getChapterKnowledges(this.materialBook.ID);
    }
  },
  watch: {
    knowledgePoints(newValue, oldValue) {
      if (!this.handleChangeFlag) {
        this.knowledgeList = [];
        if (this.knowledgeType == "chapterKnowledge") {
          this.setDefaultValue(this.bookKnowledgeOptions, []);
        } else {
          this.setDefaultValue2(this.subjectKnowledgeOptions, []);
        }
      }
      this.handleChangeFlag = false;
    },
  },
};
</script>
<style lang="less" scoped>
.el-cascader-panel {
  background: #f5f7fa !important;
}
/deep/ .knowledgeTabs.el-tabs {
  span {
    display: inline-block;
    /* max-width: 120px; */
    overflow: hidden;
    vertical-align: middle;
  }
  .el-tabs__header {
    margin: -40px 70px 2px;
    .el-tabs__item {
      font-size: 13px;
      font-weight: 400;
    }
  }
}

.casBlue {
  /deep/.el-input__inner {
    color: #409eff;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid #5c8df0 !important;
    border-radius: 0% !important;
  }
  /deep/.el-input__suffix {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail/ElementTree.vue